import React from "react";
import { Stack } from "@mui/material";

import { DataroomFiles } from "pages/Data-room-files/DataRoomFiles";

export const DataRoomsAllFile: React.FC = (): JSX.Element => {
  return (
    <Stack sx={{ flexGrow: 1, overflow: "hidden", gap: "20px", alignItems: "stretch" }}>
      <Stack flexDirection="row" justifyContent="space-between" sx={{ marginBottom: "14px" }}>
        {/* <div style={{ textAlign: "center" }}>{dataroomSyncMessage}</div> */}
      </Stack>
      <DataroomFiles />
    </Stack>
  );
};
